export default __webpack_public_path__ + "static/airbnb-4-b5187e70902b02d70883c9a7ee13b83a.png";